import React from 'react';
import NumberUtils from '../../utils/NumberUtils';

import PropTypes from 'prop-types';

function AccountTile(props) {
  return (
    <div>
      <h3 className="c-account__name">
        <a className="c-account__link" href="javascript:void(0)">
          {props.displayName}
        </a>
      </h3>
      <dl
        role="group"
        aria-labelledby="accidentifier1"
        className="c-account__defs"
      >
        <dt className="c-account__term">Sortcode</dt>
        <dd className="c-account__sortno">{props.sortCode}</dd>
        <dt className="c-account__term">Account number</dt>
        <dd className="c-account__accountno">{props.accountNumber}</dd>
        <dt className="c-account__term">Balance</dt>
        <dd className="c-account__balance">
          {props.balance !== '' &&
            NumberUtils.appendCurrency('{}', props.balance)}
        </dd>
      </dl>
    </div>
  );
}

AccountTile.propTypes = {
  displayName: PropTypes.string,
  sortCode: PropTypes.string,
  accountNumber: PropTypes.string,
  balance: PropTypes.number,
};

export default AccountTile;
